import { useEffect, useState } from 'react';
import { platformAdminApi } from '../api/platformAdminApi';
import type { PlatformTenant } from '../types/platformAdmin.types';

export const SELECT_CLASS =
  'flex h-10 w-full rounded-md border border-input bg-background px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

export function useActiveTenants(onError: (message: string) => void): PlatformTenant[] {
  const [tenants, setTenants] = useState<PlatformTenant[]>([]);
  useEffect(() => {
    void platformAdminApi
      .listTenants()
      .then(list => setTenants(list.filter(tenant => tenant.status === 'ACTIVE')))
      .catch(err => onError(err instanceof Error ? err.message : 'No se pudieron cargar los clientes'));
    // onError es estable a los efectos de la carga inicial.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return tenants;
}
